var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.currentVersion, {
    ref: "dashboard",
    tag: "component",
    attrs: {
      data: _vm.data,
      loading: _vm.loading,
      labels: _vm.labels,
      values: _vm.values,
      httpAPI: _vm.httpAPI,
      smppAPI: _vm.smppAPI,
      redirectToDocs: _vm.redirectToDocs,
      approvalStatus: _vm.approvalStatus,
      orgStatus: _vm.orgStatus,
      tableData: _vm.tableData,
      numberOfDecimal: _vm.numberOfDecimal
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }